import { RowCellContent, Table, TableBody, TableHeadColumn } from "@dash/table";
import { useTheme } from "@emotion/react";
import { MdCheck, MdClose } from "react-icons/md";

import { ProductAvailabilityReportItem } from "@megaron/crm-contracts";

type Props = {
  items: ProductAvailabilityReportItem[];
  isLoading: boolean;
};

export const ProductAvailabilityTable: React.FC<Props> = ({ items, isLoading }) => {
  const theme = useTheme();

  const tableColumns: TableHeadColumn<string>[] = [
    { isSortable: false, label: "Punkt sprzedaży" },
    { isSortable: false, label: "Region" },
    { isSortable: false, label: "Produkty" },
  ];

  const getTableRowCellsContent = (item: ProductAvailabilityReportItem): RowCellContent[] => {
    return [
      {
        isLink: true,
        element: (
          <span
            css={{
              color: theme.colors.primary,
              paddingLeft: "10px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "250px",
              display: "inline-block",
            }}
          >
            {item.posName}
          </span>
        ),
      },
      {
        isLink: false,
        element: (
          <span
            css={{
              color: theme.colors.primary,
              paddingLeft: "10px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "250px",
              display: "inline-block",
            }}
          >
            {item.regionName}
          </span>
        ),
      },
      {
        isLink: false,
        element: (
          <div
            css={{
              display: "flex",
              gap: "8px",
              overflowX: "auto",
              paddingBottom: "4px",
              maxWidth: "100%",
            }}
          >
            {item.products.map((product) => (
              <div
                key={product.itemId}
                css={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "4px 8px",
                  borderRadius: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                {product.itemName}
                {product.status === "available" ? (
                  <MdCheck size={16} color={theme.colors.success} />
                ) : (
                  <MdClose size={16} color={theme.colors.danger} />
                )}
              </div>
            ))}
          </div>
        ),
      },
    ];
  };

  return (
    <div css={{ overflow: "auto", margin: "0 -2rem 1rem" }}>
      <Table columns={tableColumns} css={{ padding: "0 2rem" }}>
        <TableBody
          isLoading={isLoading}
          rows={items.map((item) => ({
            cellsContent: getTableRowCellsContent(item),
            linkTo: `/crm/customers/id/${item.posUuid}`,
            css: {
              "&:hover": {
                "td:nth-child(1)": {
                  textDecoration: "underline",
                },
              },
            },
          }))}
        />
      </Table>
    </div>
  );
};
